module.exports = __webpack_public_path__ + "img/appBg-signup-forms--card.a47c98ab.svg";